export const data = [
  {
    id: 1,
    desc: "Equinox Tech Solutions is at the forefront of the rapidly evolving world of Virtual Reality (VR), Augmented Reality (AR), and Mixed Reality (MR). As a leader in immersive technologies                  ",
    image:
      "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/ar-vr-mr.svg",
    title: "AR VR MR Application",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/ar-vr-mr.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/arvrgif.mp4",
    bgColor: "#644b53ff",
    gifVideo:
      "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/arvrgif.mp4",
    slug: "ar-vr-mr",
  },
  {
    id: 2,
    desc: "3D modeling involves creating digital representations of objects and environments, serving as a foundational element in Virtual Reality (VR) projects. It enables the                                            ",
    image:
      "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/3d-modeling.svg",
    title: "3D Modelling",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/threedmodel.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/threedmod.gif",
    bgColor: "#FF541F",
    slug: "three-d-modeling",
  },
  {
    id: 3,
    desc: "Equinox Tech Solutions offers innovative design services that prioritize delivering exceptional user experiences. wire-framing, prototyping, visual design, usability testing, and ongoing support.                             ",
    image: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/ui-ux-design.svg",
    title: "UI UX Design",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/uiux.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/ui-ux.gif",
    bgColor: "#FF541F",
    slug: "ui-ux",
  },
  {
    id: 4,
    desc: "Equinox Tech Solutions specializes in mobile app development, including hybrid, native, and progressive web apps. We use frameworks like React Native, Flutter, and Ionic to create cross-platform            ",
    image:
      "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/app-development.svg",
    title: "App Development",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/app-dev.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/appdev.gif",
    bgColor: "#F00020",
    slug: "app-development",
  },
  {
    id: 5,
    desc: "Digital Branding is using digital platforms and strategies to communicate a brand's identity, build a positive image, and establish a strong reputation online. It helps businesses reach and  their                  ",
    image:
      "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/digital-branding.svg",
    title: "Digital Branding",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/Digital+branding.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/digitalbrand.gif",
    bgColor: "#EE6F00",
    slug: "digital-branding",
  },
  {
    id: 6,
    desc: "Protect your business with Equinox Tech Solutions' end-to-end IT security services. In today’s complex threat landscape, our expertise in GRC, TPRM, IAM, and security automation helps                                      ",
    image: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/it-security-services.svg",
    title: "IT Security Services",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/IT+Security+Services.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/itsecu.gif",
    bgColor: "#28C206",
    slug: "it-security-service",
  },
  {
    id: 7,
    desc: "Protect your business with Equinox Tech Solutions' end-to-end IT security services. In today’s complex threat landscape, our expertise in GRC, TPRM, IAM, and security automation                                                  ",
    image: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/it-consultancy.svg",
    title: "IT Consultation",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/IT+Consultation.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/itconsul.gif",
    bgColor: "#F00020",
    slug: "it-consultancy",
  },
  {
    id: 8,
    desc: "Unlock the power of the cloud with Equinox Tech Solutions' customized solutions. In today's rapidly evolving digital landscape, businesses need innovative technologies to stay competitive,                                       ",
    image:
      "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/cloud-solutions.svg",
    title: "Cloud Solutions",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/Cloud+Computing.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/cloudsol.gif",
    bgColor: "#F00020",
    slug: "cloud-solu",
  },
  {
    id: 9,
    desc: "At Equinox, from QA consulting and test planning to manual and automated testing, performance and security testing, and usability testing, our team collaborates closely with clients                                 ",
    image: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/quality-testing.svg",
    title: "Quality Testing",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/Quality+Testing.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/qualitytes.gif",
    bgColor: "#006EEE",
    slug: "quality-assuarance-testing",
  },
  {
    id: 10,
    desc: "Digital Experience refers to the overall experience that users have with digital products, services, and platforms, such as websites, mobile apps, social media, and other digital                                                 ",
    image:
      "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/digital-experince.svg",
    title: "Digital Experience",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/digiexperince.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/digiexpe.gif",
    bgColor: "#F00020",
    slug: "digital-experince",
  },
  {
    id: 11,
    desc: "Web Development refers to the process of building and maintaining websites and web applications that run online on a browser. It involves a combination of programming, design, and                                                  ",
    image: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/web-development.svg",
    title: "Web Development",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/website.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/webdev.gif",
    bgColor: "#EE6F00",
    slug: "web-development",
  },
  {
    id: 12,
    desc: "Social Media Marketing refers to the use of social media platforms to promote products, services, or brands. It involves creating and sharing content, engaging with audiences,",
    image: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/social-media-marketing.svg",
    title: "Social Media Marketing",
    video: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/socialmedia.mp4",
    gif: "https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/social-media.gif",
    bgColor: "#006EEE",
    slug: "social-media",
  },
];
